import callAccountsApi from '../data-provider'
import { normaliseBinaryPayload, printIframeDocument } from '../components/utils'

export const printInvoice = async invoice_id => {
  let pdfData = await callAccountsApi("invoices","getInvoicePDF",{invoice_id})
  let invoicePDF = normaliseBinaryPayload(pdfData.data)
  var blob = new Blob([invoicePDF], { type: 'application/pdf' })
  var blob_url = URL.createObjectURL(blob)
  var iframe = document.getElementById('pdfiframe')
  iframe.src=blob_url
  document.body.appendChild(iframe)
  await printIframeDocument(iframe)
}

export const downloadInvoice = async (invoice_id,invoicenumber) => {
  let pdfData = await callAccountsApi("invoices","getInvoicePDF",{invoice_id})
  let invoicePDF = normaliseBinaryPayload(pdfData.data)
  console.log(invoicePDF)

  var blob = new Blob([invoicePDF], { type: 'application/pdf' })
  var url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = invoicenumber + '.pdf'

  a.click()
}
